import { render, staticRenderFns } from "./sp_form.html?vue&type=template&id=3920e1d8&scoped=true&"
import script from "./sp_form.vue?vue&type=script&scoped=true&lang=js&"
export * from "./sp_form.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./sp_form.scss?vue&type=style&index=0&id=3920e1d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3920e1d8",
  null
  
)

export default component.exports